import { inject, Injectable, signal } from '@angular/core';
import { finalize, Observable, tap } from 'rxjs';
import { TourismGuidesFileApiService } from '../_api/tourism-guides-file.api.service';
import type { TourismGuideFileMultimediaType } from '../tourism-guides-file.model';

@Injectable({
	providedIn: 'root',
})
export class TourismGuideFileMultimediaTypesService {
	readonly documentTypes = signal<TourismGuideFileMultimediaType[]>([]);
	readonly isLoading = signal(false);
	readonly isCreating = signal(false);

	private readonly tourismGuidesFileApiService = inject(TourismGuidesFileApiService);

	load(): void {
		this.isLoading.set(true);
		this.tourismGuidesFileApiService
			.getTourismGuideFileMultimediaTypes()
			.pipe(finalize(() => this.isLoading.set(false)))
			.subscribe((documentTypes) => this.documentTypes.set(documentTypes));
	}

	create(name: string): Observable<TourismGuideFileMultimediaType> {
		this.isCreating.set(true);
		return this.tourismGuidesFileApiService.createTourismGuideFileMultimediaType(name).pipe(
			tap((documentType) => this.documentTypes.update((types) => [...types, documentType])),
			finalize(() => this.isCreating.set(false)),
		);
	}
}
